/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class DropDown extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			currentIndex: -1
		};

		this.onKeyUp = this.onKeyUp.bind(this);
		this.onReset = this.onReset.bind(this);
		this.clickHandler = this.clickHandler.bind(this);

	}

	componentDidMount() {

		document.addEventListener('keyup', this.onKeyUp);
		document.addEventListener('click', this.onReset);

	}

	componentWillUnmount() {

		document.removeEventListener('keyup', this.onKeyUp);
		document.removeEventListener('click', this.onReset);

	}

	clickHandler(data, event) {

		event.preventDefault();
		event.stopPropagation();
		this.props.clickHandler(data, event);

	}

	onReset (e) {
		let reset = true,
			parent = null;

		if (this.props.resetHandler) {
			parent = e.target.parentNode;
			while(parent) {
				if (parent.className &&
					(parent.className.match(/dlvr-drop-down-anchor/) || parent.className.match(/nav-container/) || parent.className.match(/control-row/))) {
					reset = false;
					parent = null;
				} else {
					parent = parent.parentNode;
				}
			}

			if (reset) {
				this.props.resetHandler(this.props.id);
			}
		}

	}

	onKeyUp(e) {
		let currentIndex = this.state.currentIndex,
			itemsLength = this.props.items.length;

		if (e.keyCode === 38 || e.keyCode === 37) {
			if ((currentIndex - 1) < 0) {
				currentIndex = itemsLength - 1;
			} else {
				--currentIndex;
			}
		} else if (e.keyCode === 40 || e.keyCode === 39) {
			if ((currentIndex + 1) >= itemsLength) {
				currentIndex = 0;
			} else {
				++currentIndex;
			}
		} else if (e.keyCode === 13) {
			if (this.state.currentIndex >= 0) {
				this.props.clickHandler(this.props.items[this.state.currentIndex], e);
			}
		} else if (e.keyCode === 27) {
			this.props.resetHandler(this.props.id);
		}

		if (currentIndex >= 0) {
			this.setState({
				currentIndex: currentIndex
			});
		}
	}

	render() {

		let output = null,
			dropDownClass = classnames('dlvr-drop-down-wrapper', this.props.dropDownClass),
			{children, ...otherProps} = this.props,
			listHeader = null,
			anchorClass = "dlvr-drop-down-anchor";

		if (this.props.listHeader !== null) {
			listHeader = React.cloneElement(this.props.listHeader, otherProps, children);
		}

		if (this.props.items.length && this.props.itemElement !== null) {
			output = (
				<div className={anchorClass}>
					<div className={dropDownClass} role="combobox" aria-expanded="true">
						{listHeader}
						<ul className="dlvr-drop-down" tabIndex="1" role="listbox">
						{this.props.items.map(function(item, i){
							let itemActive = false;

							if (this.state.currentIndex === i) {
								itemActive = true;
							}

							return(
								<this.props.itemElement {...this.props} item={item} itemActive={itemActive} key={i} clickHandler={this.clickHandler} resetHandler={this.props.resetHandler} role="option" />
							);
						}, this)}
						{this.props.pager}
						</ul>
					</div>
				</div>
			);
		}

		return output;
	}
};

DropDown.displayName = "DropDown";

DropDown.propTypes = {
	id: PropTypes.string,
	items: PropTypes.array,
	itemElement: PropTypes.func,
	dropDownClass: PropTypes.string,
	clickHandler: PropTypes.func,
	listHeader: PropTypes.element,
	resetHandler: PropTypes.func,
	pager: PropTypes.element
};

DropDown.defaultProps = {
	id: 'dropdown',
	items: [],
	itemElement: null,
	dropDownClass: "",
	clickHandler: () => {},
	listHeader: null,
	resetHandler: () => {},
	pager: null
};

export default DropDown;
